<template>
    <div>
        <form novalidate class="md-layout" @submit.prevent="validateEmail">
            <md-card class="md-layout-item md-size-40 md-small-size-100 mx-auto">
                <md-card-header>
                    <div v-show="error" class="alert alert-danger fade show" role="alert">
                        {{ alertMessage }}
                    </div>
                    <h3 class="mb-4 mt-4 font-weight-bold text-uppercase"><strong>{{$t('forgot')}}</strong> <strong class="deep-blue-text font-weight-bold">{{$t('password')}}</strong></h3>
                </md-card-header>
                <md-card-content class="ml-4 mr-4">
                    <strong>{{$t('forgot_password_text_label')}}</strong>
                    <div class="md-layout md-gutter mt-4">
                        <div class="md-layout-item md-small-size-100">
                            <md-field :class="getValidationClass('email')">
                                <md-icon>email</md-icon>
                                <label>{{$t('your_email')}}</label>
                                <md-input type="email" v-model="form.email" md-dense :disabled="sending"></md-input>
                                <span class="md-error" v-if="!$v.form.email.required">{{$t('required.email')}}</span>
                                <span class="md-error" v-else-if="!$v.form.email.email">{{$t('invalid.email')}}</span>
                            </md-field>
                        </div>
                    </div>
                </md-card-content>
                <md-progress-bar md-mode="indeterminate" v-if="sending" />
                <md-card-header class="ml-4 mr-4">
                    <btn :disabled="sending" type="submit" color="info" class="btn-block btn-rounded mb-4 mx-auto">{{$t('send_message')}}</btn>
                    <p class="small grey-text">{{$t('forgot_password_text_note')}}</p>
                </md-card-header>
            </md-card>
            <md-snackbar :md-active.sync="emailSaved">{{$t('email_sent_successfully_please_check_your_email')}} {{ lastEmail }}!</md-snackbar>
        </form>
    </div>    
</template>

<script>
import { Btn } from 'mdbvue';
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import { BASE_API } from '../helpers/base'

export default {
    name: 'ForgotPassword',
    mixins: [validationMixin],
    data(){
        return {
            form: {
                email: null
            },
            sending: false,
            emailSaved: false,
            lastEmail: null,
            error: false,
            alertMessage: null
        }
    },
    validations: {
        form: {
            email: {
                required,
                email
            }
        }
    },
    methods: {
        getValidationClass (fieldName) {
            const field = this.$v.form[fieldName]

            if (field) {
                return {
                'md-invalid': field.$invalid && field.$dirty
                }
            }
        },
        clearForm () {
            this.$v.$reset()
            this.form.email = null
        },
        sendEmail () {
            this.sending = true
            this.error = false

            let data = {
                email: this.form.email,
            }

            axios.post(`${BASE_API}/forgot_password`, data).then(resp => {
                if(resp.data.status_code === 200){
                    window.setTimeout(() => {
                        this.lastEmail = `${this.form.email}`
                        this.emailSaved = true
                        this.sending = false
                        this.clearForm()
                    }, 1500)
                }else{
                    this.sending = false
                    this.error = true;
                    this.alertMessage = this.$t('email_not_found')
                }
                    console.log(resp.data);
            }).catch(error => {
                console.log(error);
            });
        },
        validateEmail () {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.sendEmail()
            }
        }
    },
    components: {
        Btn
    }
}
</script>

<style scoped>
.md-progress-bar {
position: absolute;
top: 0;
right: 0;
left: 0;
}
@media (max-width: 425px){
.md-card-header,
.md-card-content {
margin: 0 !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue